import { get, post, put} from "../../data/api";
import { normalizePhone } from "../../services/phone";
export async function getClients() {
    return await get('client')
}
export async function getClient(id) {
    return await get('client/' + id)
}

export async function createClient(params) {
    let client = {
        Firstname: params.firstname,
        Lastname: params.lastname,
        Email: params.email,
        Phone: normalizePhone(params.phone),
        Address: params.address,
        Birthdate: params.birthdate ? new Date(params.birthdate) : null,
        Birthplace: params.birthplace,
        Comment: params.comment,
        ClientType: params.clientType,
        CompanyName: params.companyName,
        Siret: params.siret,
    };

    return await post(client, 'client')
}
export async function updateClient(params, id) {
    let bd = null;
    if (params.birthdate !== '') {
        bd = new Date(params.birthdate);
        bd.setHours(5);
    }


    let client = {
        Firstname: params.firstname,
        Lastname: params.lastname,
        Email: params.email,
        Phone: normalizePhone(params.phone),
        Address: params.address,
        Birthdate: bd,
        Birthplace: params.birthplace,
        Comment: params.comment,
        ClientType: params.clientType,
        CompanyName: params.companyName,
        Siret: params.siret,
    };

    return await put(client, 'client/' + id)
}
export async function getRentalsHistory(clientId) {
    return await get('client/' + clientId + '/rentals/')
}
export async function getVCard(clientId) {
    return await get('client/' + clientId + '/vcard/')
}
